(function($) {

    $(document).on( 'click', '#client-opener', function() {

        if ($(".client-registration-form").hasClass('show')) {
            $(".client-registration-form").removeClass('show');
        } else {
            $(".client-registration-form").addClass('show');
        }


    });


    $(document).on( 'change', '.smx-registration-form .vat input', function() {

        $(".smx-registration-form .sdi input").prop('required',true);

    });

    var country = $('.smx-registration-form .country select').val();
    if (country != 'Italy') {
        $('.smx-registration-form .state').addClass('not-show');
    }

    $(document).on( 'change', '.smx-registration-form .country select', function() {

        var country = $('.smx-registration-form .country select').val();

        if (country != 'Italy') {
            $('.smx-registration-form .state').addClass('not-show');
        } else {
            $('.smx-registration-form .state').removeClass('not-show');
        }

    });

})
(jQuery);
